import { Component, h } from "@lukekaalim/act";
import { html } from "@lukekaalim/act-web";

import classes from './index.module.css';
import { assetURLs } from "../../assets";
import { ProfileCapsuleMenu } from "../ProfileCapsuleMenu";
import { AccountDescription, UserState } from "../../defs";
import { ID } from "@kosmod/kit";
import { AuthState } from "../../hooks";

export type HeaderProps = {
  account: null | AccountDescription,
  auth: AuthState,
}

export const Header: Component<HeaderProps> = ({ account, auth }) => {
  return h(html.nav, { className: classes.header }, [
    h(html.ol, { className: classes.siteNavigationList }, [
      h(html.li, {},
        h(html.a, { className: classes.headerLogo }, h(html.img, { src: assetURLs.kosmodTransparentLogoWhite }))),
      h(html.li, {},
        h(html.a, { className: classes.headerLink }, 'Features')),
      h(html.li, {},
        h(html.a, { className: classes.headerLink }, 'Development')),
      h(html.li, {},
        h(html.a, { className: classes.headerLink }, 'Market')),
      h(html.li, {},
        h(html.a, { className: classes.headerPlusLink }, [h(html.img, {}),  'Plus'])),
    ]),
    h(html.ol, { className: classes.profileList }, [
      h(html.li, {},
        auth.authority !== 'unknown' && h(ProfileCapsuleMenu, { account: account, auth })),
    ]),
  ])
};
